import React from 'react';
import { Dialog, DialogContent } from "@mui/material";

const CategoryAcceptPopup = ({ open, onClose, handleAdminResponse, selectAlertId }) => {

  return (
     <Dialog
          open={open}
          onClose={onClose}
          PaperProps={{
            style: { borderRadius: "20px" },
          }}
        >
          <DialogContent>
            <div className="popup-accept-reject-div">
              <h3 className="delete-img-heading">Are you sure?</h3>
              <p className="delete-img-p">Do you really want to accept ?</p>
              <div className="delete-btn-div">
                <button
                  onClick={() => {
                    handleAdminResponse(selectAlertId, "accept");
                    onClose();
                  }}
                >
                  Accept
                </button>
                <button onClick={onClose}>Cancel</button>
              </div>
            </div>
          </DialogContent>
        </Dialog>
  )
}

export default CategoryAcceptPopup